<script setup lang="ts">
import { mainNavigationMedicalSystems, mainNavigationQaEquipment } from '@/components/icons/icons';
import ScopeList from '@/views/enumerations/components/ScopeList.vue';
import { useScopeOptions } from '@/components/quantitiesAndUnits/quantitiesAndUnitsUtils';
import { onMounted } from 'vue';
import FormSection from '@/components/forms/FormSection/FormSection.vue';

withDefaults(
  defineProps<{
    name: string;
    disabled?: boolean;
    allowExtend: boolean;
  }>(),
  {
    disabled: false,
  },
);

const { load, options } = useScopeOptions();

onMounted(async () => {
  await load();
});
</script>

<template>
  <FormSection :disabled="!!disabled && !allowExtend">
    <v-card class="container-level-1">
      <v-card-item
        ><v-card-title>
          <h5 class="text-h5">{{ $t('UseInTaskCategory_other') }}</h5>
        </v-card-title></v-card-item
      >
      <v-card-text>
        <!-- medical system scope -->
        <div class="d-flex">
          <div>
            <v-label>
              <v-icon
                size="40"
                class="mr-2 text-primary-darken-2"
                :icon="mainNavigationMedicalSystems"
              />
              <h6 class="text-h6 text-primary-darken-2">
                {{ $t('MedicalSystems') }}
              </h6>
            </v-label>
            <span class="sheet">
              <ScopeList
                :name="`${name}.medicalSystemScope`"
                :scopeOptions="options.medicalSystems"
                scopeKey="rtSystemCategory"
                :disabled="disabled"
                :disableSettedOptions="allowExtend"
                lastItemKey="OtherMedicalSystem"
              />
            </span>
          </div>
          <div class="vr"></div>
          <div>
            <!-- dosimetry and qa qaEquipment -->
            <v-label>
              <v-icon
                size="40"
                class="mr-2 text-primary-darken-2"
                :icon="mainNavigationQaEquipment"
              />
              <h6 class="text-h6 text-primary-darken-2">
                {{ $t('DosimetryAndQaEquipment') }}
              </h6>
            </v-label>
            <ScopeList
              :name="`${name}.qaEquipmentScope`"
              :scopeOptions="options.qaEquipment"
              scopeKey="rtSystemSubCategory"
              :disabled="disabled"
              :disableSettedOptions="allowExtend"
            />
          </div></div></v-card-text
    ></v-card>
  </FormSection>
</template>

<style scoped lang="scss">
.vr {
  width: 1px;
  background-color: rgb(var(--v-theme-primary-lighten-4));
  margin: 30px 60px;
}
</style>
